module.exports = __webpack_public_path__ + "img/student.9de8bb82.jpg";